import { render, staticRenderFns } from "./AggregatedSockOrders.vue?vue&type=template&id=37a37ea4&scoped=true"
import script from "./AggregatedSockOrders.vue?vue&type=script&lang=js"
export * from "./AggregatedSockOrders.vue?vue&type=script&lang=js"
import style0 from "./AggregatedSockOrders.vue?vue&type=style&index=0&id=37a37ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a37ea4",
  null
  
)

export default component.exports